import { xcss } from '@atlaskit/primitives';
import { type Options } from '@atlassiansox/cross-flow-support';
import { CrossflowCtaPrimaryPressable } from '@post-office/components--crossflow-cta-button';
import { type FunctionComponent } from 'react';
import { FormattedMessage } from 'react-intl-next';

import { type App } from '../../types';

const JOURNEY = 'get-started';
const SOURCE_COMPONENT = 'confluence-home-banner';
const SOURCE_CONTEXT = 'tryItNow';

const buttonText = (
	<FormattedMessage
		id="post-office.confluence-banner-first-party-recommendation.try-it-now"
		defaultMessage="Try it now"
		description={`CTA button text for the Confluence banner first party recommendation`}
	/>
);

const ctaButtonStyles = xcss({
	marginRight: 'space.1000',
	minWidth: '120px',
	color: 'color.link',
	backgroundColor: 'color.background.accent.blue.subtlest',
	paddingInline: 'space.150',
	paddingBlock: 'space.100',
	fontWeight: 'font.weight.medium',
});

export const CTAButton: FunctionComponent<{ app: App }> = ({ app }) => {
	const crossflowOptions: Options = {
		targetProduct: app.hamsIdentifier,
		journey: JOURNEY,
		sourceComponent: SOURCE_COMPONENT,
		sourceContext: SOURCE_CONTEXT,
	};

	return (
		<CrossflowCtaPrimaryPressable
			crossflowOptions={crossflowOptions}
			ctaText={buttonText}
			pressableStyle={ctaButtonStyles}
		/>
	);
};
